import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import vue from 'vue'
import config from '../../../config'

export async function getIotEvent(condition={}){
    let response={}
    let startTime = condition.startTime? encodeURIComponent(moment(condition.startTime).format().split('+')[0]) : null //2022-08-05T14:41:00+08:00 移除時區(+之後)
    let endTime = condition.endTime?  encodeURIComponent(moment(condition.endTime).format().split('+')[0]) : null//2022-08-05T14:41:00+08:00 移除時區(+之後)
    

    let queryEventType = condition.type?condition.type.map(i => `&iotEventTypes=${i}`).join(''):'';
    let queryArea = condition.scenicAreaId?`areas=${condition.scenicAreaId}`:'';
    let queryTime = `&startTime=${startTime}&endTime=${endTime}`;

    try {
        // https://localhost:44394/api/BaseData/IotEvent?areas=1&areas=2&iotEventTypes=nilometer&iotEventTypes=temperature&startTime=2024-01-25T00%3A00%3A00%2B08%3A00&endTime=2024-01-26T00%3A00%3A00%2B08%3A00
        response = await axios.get(`${config.eastCoastDataApi()}BaseData/IotEvent?${queryArea}${queryEventType}${queryTime}`)
  
    } catch (err) {
        console.error('iisi getIotEvent: ', err)
        return response
    }
    
    Utils.setApiResponsSuccess(response)
    return response.data
}


export async function getIotEventTypes(condition={}){
    let response={}
    try {
          response = await axios.get(`${config.eastCoastDataApi()}BaseData/IotEvent/GetIotEventTypes`)
    } catch (err) {
        console.error('iisi getIotEventTypes: ', err)
        return response
    }
    Utils.setApiResponsSuccess(response)
    return response.data
}
